import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    flex: 1,
  },

  // Header Section
  header: {
    marginBottom: 20,
  },

  mainTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: colors.neutral900,
    marginBottom: 4,
  },

  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    marginTop: 4,
  },

  headerItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
  },

  headerLabel: {
    fontSize: 10,
    color: colors.neutral,
  },

  headerValue: {
    fontSize: 10,
    color: colors.neutral900,
  },

  // Parties Section
  partiesSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 40,
    marginBottom: 20,
  },

  partyBox: {
    flex: 1,
    backgroundColor: colors.neutral50,
    padding: 12,
    borderRadius: 4,
  },

  partyTitle: {
    fontSize: 9,
    fontWeight: 700,
    color: colors.neutral,
    textTransform: 'uppercase',
    marginBottom: 8,
  },

  partyName: {
    fontSize: 11,
    fontWeight: 600,
    color: colors.neutral900,
    marginBottom: 2,
  },

  partyText: {
    fontSize: 10,
    color: colors.neutral700,
    marginBottom: 1,
  },

  // Period Section
  periodSection: {
    marginBottom: 20,
  },

  sectionTitle: {
    fontSize: 9,
    fontWeight: 700,
    color: colors.neutral,
    textTransform: 'uppercase',
    marginBottom: 6,
  },

  periodValue: {
    fontSize: 11,
    color: colors.neutral900,
  },

  // Items Table
  itemsSection: {
    marginBottom: 20,
  },

  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: colors.neutral50,
    paddingVertical: 8,
    paddingHorizontal: 8,
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral200,
  },

  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 8,
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral200,
  },

  colProduct: {
    width: '25%',
  },

  colPeriod: {
    width: '20%',
  },

  colDuration: {
    width: '13%',
  },

  colQty: {
    width: '8%',
    textAlign: 'center',
  },

  colPrice: {
    width: '17%',
    textAlign: 'right',
  },

  colTotal: {
    width: '17%',
    textAlign: 'right',
  },

  tableHeaderText: {
    fontSize: 8,
    fontWeight: 700,
    color: colors.neutral,
    textTransform: 'uppercase',
  },

  tableCellText: {
    fontSize: 10,
    color: colors.neutral900,
  },

  tableCellTextSmall: {
    fontSize: 8,
    color: colors.neutral,
  },

  // Totals Section
  totalsSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 20,
  },

  totalsBox: {
    width: 200,
    backgroundColor: colors.neutral50,
    padding: 12,
    borderRadius: 4,
  },

  totalRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },

  totalLabel: {
    fontSize: 10,
    color: colors.neutral700,
  },

  totalValue: {
    fontSize: 10,
    color: colors.neutral900,
  },

  grandTotalRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: colors.neutral200,
    paddingTop: 8,
    marginTop: 4,
  },

  grandTotalLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: colors.neutral900,
  },

  grandTotalValue: {
    fontSize: 11,
    fontWeight: 700,
    color: colors.neutral900,
  },

  // Payment Terms Section
  termsSection: {
    borderTopWidth: 1,
    borderTopColor: colors.neutral200,
    paddingTop: 16,
  },

  termsContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  termRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
  },

  termLabel: {
    fontSize: 10,
    color: colors.neutral,
  },

  termValue: {
    fontSize: 10,
    color: colors.neutral900,
  },

  // Per-product terms
  productTermsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },

  productTermsBox: {
    backgroundColor: colors.neutral50,
    padding: 10,
    borderRadius: 4,
  },

  productTermsName: {
    fontSize: 10,
    fontWeight: 600,
    color: colors.neutral900,
    marginBottom: 4,
  },
});
